import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { NotificationConfigIconOutputDto } from 'src/app/organization/notification-configuration/dto/notification-config-icon-output.dto';
import { NotificationConfigService } from 'src/app/organization/notification-configuration/services/notification-config.service';
import { SensorTypeConfig } from 'src/app/_shared/models/sensor-type-config';
import { SensorTypesService } from 'src/app/public-utility/sensor-types/services/sensor-types.service';
import { ApiService } from 'src/app/_core/services/api/api.service';
import { InfoTextService } from 'src/app/organization/notification-configuration/services/info-text.service';

interface NotificationConfigurationCreateResolverResult {
  icons: NotificationConfigIconOutputDto[];
  sensorTypeConfigs: SensorTypeConfig[];
}

@Injectable({
  providedIn: 'root',
})
export class NotificationConfigurationEditResolver
  implements Resolve<void | NotificationConfigurationCreateResolverResult> {
  constructor(
    private notificationConfigService: NotificationConfigService,
    private sensorTypesService: SensorTypesService,
    private infoTextService: InfoTextService,
    private apiService: ApiService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<void | NotificationConfigurationCreateResolverResult> {
    const promises = [];
    promises.push(
      this.notificationConfigService.getById(route.params.id, false)
    );
    promises.push(this.notificationConfigService.getIconList(false));
    promises.push(this.sensorTypesService.getSensorTypeConfigs(false));
    promises.push(this.infoTextService.getInfoTextList());

    return Promise.all(promises)
      .then((allPromisesResult) => {
        return {
          notificationConfig: allPromisesResult[0],
          icons: allPromisesResult[1],
          sensorTypeConfigs: allPromisesResult[2],
          infoTexts: allPromisesResult[3],
        } as NotificationConfigurationCreateResolverResult;
      })
      .catch((err) => {
        this.apiService.handleError(err);
        throw err;
      });
  }
}
